import React from "react";
import Error from "../icons/error.png";

const ErrorToast = ({ handleToast, message, visible }) => {
  return (
    <div
      className={`fixed inset-0 z-50 overflow-auto bg-gray-900 bg-opacity-50 p-6 flex justify-center items-center transition-opacity ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className="bg-transparent flex flex-col items-center justify-center gap-2 rounded-lg w-full mx-auto p-7 bg-white transition-transform transform scale-100 hover:scale-105"
        style={{ maxWidth: "500px" }}
      >
        <div className="w-full p-2 flex items-center justify-center">
          <img src={Error} className="w-36 h-36" />
        </div>
        <h1 className="text-center text-slate-700 font-normal text-2xl">
          Error!
        </h1>
        <div className="w-full flex items-center justify-center gap-2 text-slate-600">
          <p>{message}</p>
        </div>
        <button
          className="w-full mt-4 rounded-md text-baseFont bg-customOrange text-white py-2"
          onClick={handleToast}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default ErrorToast;
